import { RootState } from "../reducers";

export const getLayerTempFilterTool = ({ layerTempFilter }: RootState) => layerTempFilter.tool;

export const getLayerTempFilterId = ({ layerTempFilter }: RootState) => layerTempFilter.id;
